import SchoolInfrastructure from "../components/gallery/SchoolInfrastructure";
import EventsCelebrations from "../components/gallery/EventsCelebrations";
import ClassroomActivities from "../components/gallery/ClassroomActivities";


const Gallery = () => {
  return (
    <div>
        <SchoolInfrastructure/>
        <EventsCelebrations/>
        <ClassroomActivities />
    
        


    </div>
  );
};

export default Gallery;
